const routes = [
    {
        path: '/contabilidade/adm',
        alias: ['/contabilidade/adm/index'],
        component: () => import('../views/administrativo/Listar')
    },
    {
        path: '/contabilidade/adm/visualizar/:id',
        component: () => import('../views/administrativo/Visualizar')
    },
    {
        path: '/contabilidade/adm/enviar_mensagem',
        component: () => import('../views/administrativo/Adicionar')
    },

    {
        path: '/contabilidade/contabeis',
        alias: ['/contabilidade/contabeis/index'],
        component: () => import('../views/contabeis/Listar')
    },
    {
        path: '/contabilidade/contabeis/visualizar/:id',
        component: () => import('../views/contabeis/Visualizar')
    },
    {
        path: '/contabilidade/contabeis/enviar_mensagem',
        component: () => import('../views/contabeis/Adicionar')
    },

    {
        path: '/contabilidade/fiscais',
        alias: ['/contabilidade/fiscais/index'],
        component: () => import('../views/fiscais/Listar')
    },
    {
        path: '/contabilidade/fiscais/visualizar/:id',
        component: () => import('../views/fiscais/Visualizar')
    },
    {
        path: '/contabilidade/fiscais/enviar_mensagem',
        component: () => import('../views/fiscais/Adicionar')
    },

    {
        path: '/contabilidade/pessoal',
        alias: ['/contabilidade/pessoal/index'],
        component: () => import('../views/pessoal/Listar')
    },
    {
        path: '/contabilidade/pessoal/visualizar/:id',
        component: () => import('../views/pessoal/Visualizar')
    },
    {
        path: '/contabilidade/pessoal/enviar_mensagem',
        component: () => import('../views/pessoal/Adicionar')
    },

    {
        path: '/contabilidade/registros_empresas',
        alias: ['/contabilidade/registros_empresas/index'],
        component: () => import('../views/registros_empresas/Listar')
    },
    {
        path: '/contabilidade/registros_empresas/visualizar/:id',
        component: () => import('../views/registros_empresas/Visualizar')
    },
    {
        path: '/contabilidade/registros_empresas/enviar_mensagem',
        component: () => import('../views/registros_empresas/Adicionar')
    }
]

export default routes
